import { render, staticRenderFns } from "./ZoneDetail.vue?vue&type=template&id=031d7d44"
import script from "./ZoneDetail.vue?vue&type=script&lang=js"
export * from "./ZoneDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports